'use client';

import './sider-right.scss';
import { useContentSize } from '@/components/SizeProvider';
import {useEffect, useRef, useState} from 'react';
import {ProjectModel} from '@/lib/models/Project';
import {usePathname} from 'next/navigation';
import ListProject from './ListProject';
import {RouterName} from '@/lib/enum/RouterEnum';
import { useIsSafari } from '@/lib/hooks/useIsSafari';
import ContactInfo from './ContactInfo';

interface Props {
  projects: ProjectModel[];
}

const SiderRight = ({ projects }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  const { width: widthContent, height: heightContent } = useContentSize();
  const width = (widthContent - (heightContent * 16 / 15 + 160)) / 2;
  const isSafari = useIsSafari();

  const pathname = usePathname();
  const [idActive, setIdActive] = useState(0);

  useEffect(() => {
    if (pathname?.includes(RouterName.projectDetail)) {
      const slug = pathname.replace(`${RouterName.projectDetail}/`, '');
      const projectActive = projects.find(item => item.slug === slug);
      if (projectActive) {
        setIdActive(projectActive.id);
      }
    }
    // Don't highlight anything when we navigate to homepage
    else {
      setIdActive(0);
    }
  }, [pathname, projects]);

  return (
    <div ref={ref} className='sider-right' style={{
      width: width,
      fontSize: widthContent / 180,
      height: heightContent * 0.8,
      fontWeight: isSafari ? 500 : 700 // Sean Ngo: Safari looks weird with 500 font weight 
    }}>
      <ListProject idActive={idActive} listProject={projects}/>
      <ContactInfo/>
    </div>
  )
};

export default SiderRight;
  